import MuiButton from './MuiButton';

const index = {
    MuiButton,
};

export default index;
